import styled_components, { css, keyframes } from "styled-components";
const pulseShadow = /*#__PURE__*/ keyframes([
    "0%{box-shadow:0px 0px 30px 15px rgba(193,192,192,0.4);}50%{box-shadow:0px 0px 10px 5px rgba(64,64,64,0.6);}100%{box-shadow:0px 0px 30px 15px rgba(193,192,192,0.4);}"
]);
const Container = /*#__PURE__*/ styled_components.div.withConfig({
    displayName: "BotWithAnumatedBorder.styles__Container"
})([
    "display:flex;flex-direction:column;align-items:center;justify-content:center;"
]);
const LogoWrapper = /*#__PURE__*/ styled_components.div.withConfig({
    displayName: "BotWithAnumatedBorder.styles__LogoWrapper"
})([
    "width:88px;height:88px;position:relative;top:50px;display:flex;border-radius:50%;align-items:center;justify-content:center;",
    ""
], ({ isSpeaking })=>isSpeaking && /*#__PURE__*/ css([
        "animation:",
        " 2.5s cubic-bezier(0.42,0,0.58,1) infinite;"
    ], pulseShadow));
const Logo = /*#__PURE__*/ styled_components.img.withConfig({
    displayName: "BotWithAnumatedBorder.styles__Logo"
})([
    "width:100%;height:100%;border-radius:50%;"
]);
const ToggleButton = /*#__PURE__*/ styled_components.button.withConfig({
    displayName: "BotWithAnumatedBorder.styles__ToggleButton"
})([
    "margin-top:20px;padding:10px 20px;font-size:16px;cursor:pointer;"
]);
export { Container, Logo, LogoWrapper, ToggleButton };
